import { memo, PropsWithChildren } from 'react';
import { CollapseCard, Heading, Status } from 'plume-ui';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

export type OutreachConfigSectionProps = {
  title: string;
  subtitle: string;
  isRequired: boolean;
  isComplete: boolean;
  isOpen?: boolean;
  hideComplete?: boolean;
};

const OutreachConfigSection = ({
  title,
  subtitle,
  isRequired,
  isComplete,
  isOpen = true,
  children,
  hideComplete = false,
}: PropsWithChildren<OutreachConfigSectionProps>) => {
  const { t } = useTranslation();
  return (
    <CollapseCard
      open={isOpen}
      classes={(current) => ({
        ...current,
        root: `${current.root} OutreachContainer__section-card`,
      })}
      title={
        <div className="OutreachContainer__section-title">
          <Heading size="xl">{title}</Heading>
          <div className="OutreachContainer__section-subtitle">
            <Heading size="s">{subtitle}</Heading>
          </div>
        </div>
      }
      actions={[
        isRequired && !hideComplete && (
          <Status
            classes={(current) => ({
              ...current,
              indicator: cx('OutreachContainer__section-status-indicator'),
              root: `${current.root} OutreachContainer__section-status`,
              label: cx(current.root, {
                'OutreachContainer__section-status-label': true,
                'OutreachContainer__section-status-label--ok': isComplete,
                'OutreachContainer__section-status-label--warning': !isComplete,
              }),
            })}
            color={isComplete ? 'ok' : 'warning'}
            label={isComplete ? t('complete') : t('incomplete')}
          />
        ),
      ]}
    >
      {isOpen && (
        <div className="OutreachContainer__section-wrapper">{children}</div>
      )}
    </CollapseCard>
  );
};

export default memo(OutreachConfigSection);
